// extracted by mini-css-extract-plugin
export default {"statisticsMain":"statistics_statisticsMain__4uBdG","statisticsListWrapper":"statistics_statisticsListWrapper__eqS0b"};